var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtlStateNoEtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 3,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 877,
    y: 398,
    width: 14,
    height: 3,
    rx: 1.5,
    transform: "translate(-877 -398)",
    fill: "#CCC",
    fillRule: "evenodd"
  })));
}
export default SvgEtlStateNoEtl;